import { render } from "./DataTradingInfoList.vue?vue&type=template&id=6356a0d0&scoped=true"
import script from "./DataTradingInfoList.vue?vue&type=script&lang=js"
export * from "./DataTradingInfoList.vue?vue&type=script&lang=js"

import "./DataTradingInfoList.vue?vue&type=style&index=0&id=6356a0d0&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6356a0d0"]])

export default __exports__